import React, { useEffect, useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { useReactToPrint } from "react-to-print";
import LayoutV2 from "containers/LayoutV2";
import moment from "moment";
import PrintFileApi from "service/PrintFileApi";

export const ThoaThuanSuDung = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [agreementHtml, setAgreementHtml] = useState("");
  const [timeChapThuan, setTimeChapThuan] = useState("");
  const [loading, setLoading] = useState(false);
  const [isExportingPDF, setIsExportingPDF] = useState(false);
  const printRef = useRef(null);

  useEffect(() => {
    document.title = "Thỏa thuận sử dụng | Phần mềm quản lý cầm đồ - Morman";

    const fetchAgreement = async () => {
      setLoading(true);
      try {
        const response = await PrintFileApi.getDieuKhoan();
        if (response && response.ok) {
          setAgreementHtml(response.data.ThoaThuan || "");
          setTimeChapThuan(response.data.NgayChapThuan);
        } else {
          console.error("Lỗi lấy thỏa thuận:", response);
          setAgreementHtml("<p>Không tải được nội dung thỏa thuận.</p>");
        }
      } catch (err) {
        console.error("Lỗi lấy thỏa thuận:", err);
        setAgreementHtml("<p>Không tải được nội dung thỏa thuận.</p>");
      } finally {
        setLoading(false);
      }
    };

    fetchAgreement();
  }, []);

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: "ThoaThuanSuDung_MORMAN",
    pageStyle: `
      @page {
        size: A4;
        margin: 20mm;
      }
      .print-content-wrapper {
        color: #2B335E !important;
        background: #fff !important;
        font-size: 14pt !important;
      }
    `,
  });

  const XuatPDF = async () => {
    if (isExportingPDF) return;
    setIsExportingPDF(true);
    const fileCode = "ThoaThuanSuDung";
    try {
      const response = await PrintFileApi.xuatPDFDieuKhoan();
      const url = window.URL.createObjectURL(response.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${fileCode}_${moment().format("YYYYMMDDHHmm")}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Lỗi tải PDF:", err);
    } finally {
      setIsExportingPDF(false);
    }
  };

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const modalCustomStyle = `
    .modal-70 {
      max-width: 75vw !important;
      width: 75vw !important;
      color: #2B335E !important;
    }

    .table-card {
      background: #fff;
      border: 1px solid #dee2e6;
      border-radius: 8px;
      color: #2B335E !important;
    }

    .table-card table {
      width: 100%;
      border-collapse: collapse;
      color: #2B335E !important;
    }

    .table-card th,
    .table-card td {
      padding: 12px 10px;
      border: 1px solid #e9ecef;
      vertical-align: middle;
      color: #2B335E !important;
    }

    .table-card th {
      font-weight: 600;
      color: #2B335E !important;
    }

    .action-button {
      min-width: 120px;
    }

    @media print {
      .print-content-wrapper {
        background: white !important;
      }
    }
  `;

  return (
    <LayoutV2>
      <>
        <style>{modalCustomStyle}</style>

        <div id="form-repeater" className="p-1">
          <div className="row header justify-content-start ml-1">
            <img
              src="/app-assets/images/icon-cau-hinh.png"
              alt="Mẫu hợp đồng"
            />
            <h1 className="text-info-home">Thỏa thuận sử dụng</h1>
          </div>
          <div className="p-1"></div>
          <div className="table-card">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Tên văn bản</th>
                  <th>Phiên bản / Cập nhật</th>
                  <th>Thời gian đồng ý</th>
                  <th>Hành động</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>Thỏa thuận sử dụng phần mềm Morman</td>
                  <td>Phiên bản V1.1 - 01/04/2026</td>
                  <td>{timeChapThuan}</td>
                  <td>
                    <button
                      type="button"
                      className="btn btn-primary action-button"
                      onClick={openModal}
                    >
                      Xem
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <Modal
          show={showModal}
          onHide={closeModal}
          dialogClassName="modal-70"
          centered
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <h4 className="modal-title color7-bold" id="myModalLabel16">
              <span className="btn-icon-right">
                <img
                  src={"/app-assets/images/icon-editphieuthuchi.png"}
                  alt="icon"
                />
              </span>
              Thảo thuận sử dụng
            </h4>
            <button
              type="button"
              className="close-popup-new"
              onClick={closeModal}
            >
              ×
            </button>
          </Modal.Header>
          <Modal.Body>
            <div
              className="agreement-content"
              dangerouslySetInnerHTML={{
                __html: loading
                  ? "<p>Đang tải thỏa thuận...</p>"
                  : agreementHtml ||
                    "<p>Không tải được nội dung thỏa thuận.</p>",
              }}
            />

            <div className="d-flex justify-content-center flex-wrap gap-2 mt-3 no-print">
              <button
                type="button"
                className="btn btn-new-main btn-closenew"
                onClick={closeModal}
              >
                <span>
                  <i className="mdi mdi-close"></i>
                </span>
                &nbsp; Đóng &nbsp;
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-new-main btn-checknew"
                onClick={XuatPDF}
                disabled={isExportingPDF}
              >
                {isExportingPDF ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-1"
                      role="status"
                    />
                    &nbsp; Đang xuất... &nbsp;
                  </>
                ) : (
                  <>
                    <span>
                      <i className="fas fa-file-pdf me-1"></i>
                    </span>
                    &nbsp; Xuất PDF &nbsp;
                  </>
                )}
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-new-main btn-checknew"
                onClick={handlePrint}
              >
                <span>
                  <i className="fas fa-print me-1"></i>
                </span>
                &nbsp; In thỏa thuận &nbsp;
              </button>
            </div>
          </Modal.Body>
        </Modal>

        <div style={{ display: "none" }}>
          <div id="htmlPrint" ref={printRef} className="print-content-wrapper">
            <div dangerouslySetInnerHTML={{ __html: agreementHtml }} />
          </div>
        </div>
      </>
    </LayoutV2>
  );
};
